"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreTypeType = void 0;
var ScoreTypeType;
(function (ScoreTypeType) {
    ScoreTypeType[ScoreTypeType["Period"] = 0] = "Period";
    ScoreTypeType[ScoreTypeType["YellowCard"] = 1] = "YellowCard";
    ScoreTypeType[ScoreTypeType["Goal"] = 2] = "Goal";
    ScoreTypeType[ScoreTypeType["Game"] = 3] = "Game";
    ScoreTypeType[ScoreTypeType["Corner"] = 4] = "Corner";
    ScoreTypeType[ScoreTypeType["Rank"] = 5] = "Rank";
    ScoreTypeType[ScoreTypeType["Series"] = 6] = "Series";
    ScoreTypeType[ScoreTypeType["Aggregate"] = 7] = "Aggregate";
    ScoreTypeType[ScoreTypeType["Golf"] = 8] = "Golf";
    ScoreTypeType[ScoreTypeType["Live"] = 9] = "Live";
    ScoreTypeType[ScoreTypeType["YellowRedCard"] = 10] = "YellowRedCard";
    ScoreTypeType[ScoreTypeType["RedCard"] = 11] = "RedCard";
    ScoreTypeType[ScoreTypeType["Climber"] = 12] = "Climber";
    ScoreTypeType[ScoreTypeType["Sprint"] = 13] = "Sprint";
    ScoreTypeType[ScoreTypeType["ClimberRanking"] = 14] = "ClimberRanking";
    ScoreTypeType[ScoreTypeType["SprintRanking"] = 15] = "SprintRanking";
    ScoreTypeType[ScoreTypeType["Time"] = 16] = "Time";
    ScoreTypeType[ScoreTypeType["TimeRanking"] = 17] = "TimeRanking";
    ScoreTypeType[ScoreTypeType["Overtime"] = 18] = "Overtime";
    ScoreTypeType[ScoreTypeType["Penalties"] = 19] = "Penalties";
    ScoreTypeType[ScoreTypeType["Other"] = 20] = "Other";
})(ScoreTypeType = exports.ScoreTypeType || (exports.ScoreTypeType = {}));
